import { createAsyncThunk } from '@reduxjs/toolkit'

import { IEventData } from 'meta/pages/v4/event'
import { EventController } from 'controller/event'

type Returned = IEventData[]

type Props = {
  idsOrCodeUrls: string[]
}

export const getBulkData = createAsyncThunk<Returned, Props>('pages/event/bulk', async (props) => {
  const { idsOrCodeUrls } = props

  const data = await EventController.getBulkData({ idsOrCodeUrls })

  return data.items
})
